{
  "Accessibility Menu": "Saavutettavuusvalikko",
  "Reset settings": "Palauta asetukset",
  "Close": "Sulje",
  "Content Adjustments": "Sisällön säädöt",
  "Adjust Font Size": "Säädä fonttikokoa",
  "Highlight Title": "Korosta otsikko",
  "Highlight Links": "Korosta linkit",
  "Readable Font": "Helposti luettava fontti",
  "Color Adjustments": "Värien säädöt",
  "Dark Contrast": "Tumma kontrasti",
  "Light Contrast": "Vaalea kontrasti",
  "High Contrast": "Korkea kontrasti",
  "High Saturation": "Korkea kylläisyys",
  "Low Saturation": "Matala kylläisyys",
  "Monochrome": "Yksivärinen",
  "Contrast": "Kontrasti",
  "Invert Colors": "Käännä värit",
  "Tools": "Työkalut",
  "Reading Guide": "Lukemisopas",
  "Stop Animations": "Pysäytä animaatiot",
  "Big Cursor": "Iso kohdistin",
  "Increase Font Size": "Suurenna fonttikokoa",
  "Decrease Font Size": "Pienennä fonttikokoa",
  "Letter Spacing": "Kirjainten välistys",
  "Line Height": "Rivin korkeus",
  "Font Weight": "Fontin paksuus",
  "Dyslexia Font": "Dysleksiafontti",
  "Language": "Kieli",
  "Open Accessibility Menu": "Avaa saavutettavuusvalikko",
  "Widget Settings": "Widget-asetukset",
  "Widget Position": "Widgetin sijainti",
  "Top Left": "Ylä vasen",
  "Top Center": "Ylä keskellä",
  "Top Right": "Ylä oikea",
  "Center Left": "Keskellä vasen",
  "Center Right": "Keskellä oikea",
  "Bottom Left": "Ala vasen",
  "Bottom Center": "Ala keskellä",
  "Bottom Right": "Ala oikea",
  "Screen Reader": "Näytönlukija",
  "Voice Navigation": "Ääniopastus",
  "Custom Color": "Mukautettu väri",
  "Change the site's colors": "Vaihda sivuston värit",
  "Backgrounds": "Taustat",
  "Headings": "Otsikot",
  "Contents": "Sisällöt",
  "Reset colors": "Nollaa värit",
  "Image Desaturation": "Kuvan värittömyys",
  "Search languages": "Hae kieliä",
  "No languages found": "Kieliä ei löytynyt",
  "Accessibility Profiles": "Esteettömyysprofiilit",
  "Motor Impaired": "Motorinen rajoite",
  "Big cursor, voice navigation, and no animations.": "Iso kohdistin, ääniohjaus eikä animaatioita.",
  "Blind": "Sokea",
  "Screen reader helpers with higher contrast.": "Ruudunlukuavustimet korkeammalla kontrastilla.",
  "Color Blind": "Värisokeus",
  "High contrast palette with desaturated media.": "Korkeakontrastinen paletti ja kyllästymättömät mediat.",
  "Dyslexia": "Lukihäiriö",
  "Friendly font, extra spacing, stronger weight.": "Helppolukuinen fontti, enemmän väliä ja vahvempi paino.",
  "Low vision": "Heikko näkö",
  "Dark contrast and 130% magnification.": "Tumma kontrasti ja 130 % suurennus.",
  "Cognitive & Learning": "Kognitiivinen ja oppiminen",
  "Highlights key sections and enables voice help.": "Korostaa tärkeät osiot ja ottaa ääniavun käyttöön.",
  "Seizure & Epileptic": "Kohtaukset ja epilepsia",
  "Stops animations and desaturates imagery.": "Pysäyttää animaatiot ja vähentää kuvien kylläisyyttä.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "Lukuopas, korostetut linkit ja rauhallisempi paletti.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
